import { useAuthentication } from '../../Login/hooks/useAuthentication';
import { useAuthenticationStore } from '../../state/authenticationStore';

export const useDenyGCAccessIfUnauthorized = (canGCAddDraw: boolean | undefined) => {
    const { authentication } = useAuthentication();
    const selectedAuthorizedDrawUserEntity = useAuthenticationStore((s) => s.selectedEntity);

    if (!authentication?.user.isGeneralContractor) {
        return false;
    }

    if (selectedAuthorizedDrawUserEntity != null && !canGCAddDraw) {
        return true;
    } else {
        return false;
    }
};
